import { styled } from "@washingtonpost/wpds-theme";

export const ScrubberWrapper = styled("button", {
  backgroundColor: "transparent",
  border: "none",
  width: "100%",
  paddingTop: "8px",
  paddingBottom: "4px",
  cursor: "pointer",
  touchAction: "none"
});

export const ScrubberProgress = styled("div", {
  background: "$gray20",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  height: "100%",
  borderRadius: "3px",
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  cursor: "pointer"
});

export const ScrubberBar = styled("div", {
  position: "relative",
  borderRadius: "3px"
});

export const ScrubberDot = styled("div", {});
